import { render, staticRenderFns } from "./ParticipantList.vue?vue&type=template&id=2f36d6ea&scoped=true&"
import script from "./ParticipantList.vue?vue&type=script&lang=js&"
export * from "./ParticipantList.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantList.vue?vue&type=style&index=0&id=2f36d6ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f36d6ea",
  null
  
)

export default component.exports